import axios from 'axios';

export const getData = () => {
  const instance = axios.create({baseURL: process.env.REACT_APP_EXPRESS_ENDPOINT});
  return instance.get('/express_backend/')
    .then(res => res.data)
    .then(data => data)
    .catch(err => console.log(err))
}